/**
 * Created by anatoly on 28.08.2024
 */

const DangerComponent = function (duration) {
    cleverapps.EventEmitter.call(this);

    this.duration = duration;
    this.timer = Game.currentGame.timer;

    this.noMuchTime = false;

    this.started = false;
    this.stopped = false;

    this.timer.on("onSecond", this.onSecond.bind(this));
};

DangerComponent.prototype = Object.create(cleverapps.EventEmitter.prototype);
DangerComponent.prototype.constructor = DangerComponent;

DangerComponent.prototype.getTimeLeft = function () {
    return Math.max(this.duration - (this.timer.getInGameTime() * 1000), 0);
};

DangerComponent.prototype.isFinished = function () {
    return this.getTimeLeft() === 0;
};

DangerComponent.prototype.getPercentOfCompletion = function () {
    if (!this.duration) {
        throw new Error("Not danger duration!");
    }

    return (this.duration - this.getTimeLeft()) / this.duration;
};

DangerComponent.prototype.onSecond = function () {
    if (!this.started) {
        this.started = true;
        this.trigger("onStart");
    }

    if (!this.noMuchTime && this.getPercentOfCompletion() > 0.7) {
        this.noMuchTime = true;
        this.trigger("onNoMuchTime");
    }

    if (this.isFinished()) {
        this.onFinish();
    }

    this.trigger("update");
};

DangerComponent.prototype.onFinish = function () {
    Game.currentGame.counter.trigger();
};

DangerComponent.prototype.stop = function () {
    this.stopped = true;
    this.trigger("onStop");
};